
import React, { useEffect, useState } from 'react';
import ChangePasswordForm from '../UpdatePassword';
import LoadingAnimation from '../../components/LoadingAnimation/LoadingAnimation';
import Accordion from '../../components/Accordianitem/Accordion';
import TwoFactorAuth from '../TwoFactorAuth';
import Communication from '../Communication';



interface SubjectiveContentProps {
  id: string;
}

const Settings: React.FC<SubjectiveContentProps> = () => {
  const [loading, setLoading] = useState(true);

  
  useEffect(() => {
    const loadData = async () => {
     
      await new Promise(resolve => setTimeout(resolve, 2000)); 
      setLoading(false); 
    };

    loadData();
  }, []);

  const accordionItems = [
    { title: <span className='font-jost text-lg'>Update Password</span>, content: <ChangePasswordForm /> },
    { title: <span className='font-jost text-lg'>2FA</span>, content: <TwoFactorAuth /> },
    { title: <span className='font-jost text-lg'>Communication</span>, content: <Communication /> },
  ];

  return (
    <div className="py-4 mt-6"> 
      {loading ? ( 
        <div className="flex justify-center items-center h-full bg-[#eaeaea]">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
        </div>
      ) : (
        <Accordion items={accordionItems} />
      )}
    </div>
  );
};

export default Settings;
